import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useGameStore } from '../stores/gameStore';
import { useAds } from '../hooks/useAds';
import { playClick } from '../utils/audio';

export const GameOver = () => {
  const { score, bestScoreAllTime, bestScoreToday, restart, phase, currentLevel } = useGameStore();
  const { showInterstitial, showRewarded } = useAds();
  const [showContinue, setShowContinue] = useState(true);
  const isNewBest = score > bestScoreAllTime;

  useEffect(() => {
    if (phase === 'gameOver') {
      void showInterstitial();
    }
  }, [phase, showInterstitial]);

  const handleRestart = () => {
    playClick();
    void showInterstitial();
    restart();
  };

  const handleContinue = async () => {
    playClick();
    await showRewarded();
    setShowContinue(false);
    // Continue logic would go here (revive snake at safe position)
  };

  const handleShare = async () => {
    playClick();
    const text = `I scored ${score} on Snake Nostalgia! Beat me?`;
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ text, url, title: 'Snake Nostalgia' });
      } catch {
        // ignore
      }
    } else {
      try {
        await navigator.clipboard?.writeText(`${text} ${url}`);
        alert('Share text copied! Paste it anywhere to challenge friends.');
      } catch {
        // ignore
      }
    }
  };

  if (phase !== 'gameOver') return null;

  return (
    <motion.div
      className="gameover-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="gameover-card nokia-style">
        <div className="nokia-screen-content">
          {isNewBest && (
            <motion.div
              className="new-best"
              initial={{ scale: 0, rotate: -10 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: 'spring' }}
            >
              🏆 NEW BEST!
            </motion.div>
          )}

          <div className="gameover-title">GAME OVER</div>
          <div className="final-score">{score.toString().padStart(4, '0')}</div>
          
          <div className="score-details">
            <div>BEST: {bestScoreAllTime.toString().padStart(4, '0')}</div>
            <div>TODAY: {bestScoreToday.toString().padStart(4, '0')}</div>
            <div>LEVEL: {currentLevel}</div>
          </div>

          <div className="action-buttons">
            {showContinue && (
              <motion.button
                className="continue-btn nokia-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleContinue}
              >
                ↻ CONTINUE? (Ad)
              </motion.button>
            )}

            <motion.button
              className="restart-btn nokia-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleRestart}
            >
              🔄 PLAY AGAIN
            </motion.button>

            <button className="share-btn nokia-btn" onClick={handleShare}>
              📱 SHARE
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default GameOver;
